<template>
<div class="chapter">
<div class="inner_page">
<h1 id="HalfTitle">Murder on Mt. McKinley</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HalfTitle.vue?26f1acde